// Minimal helpers for cart count refresh
document.addEventListener('DOMContentLoaded', function(){
  fetch('/cart.js').then(r=>r.json()).then(c=>{
    var el=document.querySelector('[data-cart-count]');
    if(el) el.textContent = c.item_count;
  }).catch(()=>{});
});
document.querySelectorAll('.hero-carousel').forEach(function(carousel) {
  const track = carousel.querySelector('.hero-carousel-track');
  const slides = carousel.querySelectorAll('.hero-slide');
  const dots = carousel.querySelectorAll('.hero-dot-nav');
  if (slides.length <= 1) return;

  let index = 0;
  function goTo(i) {
    index = (i + slides.length) % slides.length;
    track.style.transform = `translateX(-${index * 100}%)`;
    dots.forEach((d, di) => d.classList.toggle('active', di === index));
  }
  dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));
  goTo(0);

  if (carousel.dataset.autoplay === 'true') {
    const speed = parseInt(carousel.dataset.speed) || 4000;
    setInterval(() => goTo(index + 1), speed);
  }
});
const navToggle = document.querySelector('.nav-toggle');
const mobileNav = document.querySelector('.mobile-nav');
const overlay = document.querySelector('.mobile-nav-overlay');

if (navToggle && mobileNav && overlay) {
  function closeMenu() {
    navToggle.classList.remove('active');
    mobileNav.classList.remove('open');
    overlay.classList.remove('open');
    navToggle.setAttribute('aria-expanded', 'false');
  }
  function openMenu() {
    navToggle.classList.add('active');
    mobileNav.classList.add('open');
    overlay.classList.add('open');
    navToggle.setAttribute('aria-expanded', 'true');
  }
  navToggle.addEventListener('click', () => {
    mobileNav.classList.contains('open') ? closeMenu() : openMenu();
  });
  overlay.addEventListener('click', closeMenu);
  const mobileNavClose = document.querySelector('.mobile-nav-close');
if (mobileNavClose) mobileNavClose.addEventListener('click', closeMenu);
  mobileNav.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
}